import { Component, OnInit, Inject, ViewChild,ViewChildren, ElementRef ,QueryList} from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import { apiService } from '../../../../../service/api.service';
import { MatDialog } from '@angular/material/dialog';
import { ResponseMedioVerificacionModel, MedioVerificacionAsociarModel, VinculadoModel} from '../../../../../model/Etapas.model'
import { MatCheckbox } from '@angular/material/checkbox';
import { StorageService } from 'src/app/service/storage.service';

@Component({
  selector: 'app-modal-autoevaluacion-medios-verificacion',
  templateUrl: './modal-autoevaluacion-medios-verificacion.component.html',
  styleUrls: ['./modal-autoevaluacion-medios-verificacion.component.css']
})
export class ModalAutoevaluacionMediosVerificacionComponent implements OnInit {
  idElementoGestion = 0;
  vinculados = Array<VinculadoModel>();
  cargando = true;
  mediosVerificacion = new  Array<MedioVerificacionAsociarModel>();
  checked = false;
  vinculado = new Array<VinculadoModel>();
  cantidadAsociada = 0;
  @ViewChildren('check') check:QueryList<any>;
  constructor(
    public api:apiService,
    public storageService: StorageService,
    public dialogRef: MatDialogRef<ModalAutoevaluacionMediosVerificacionComponent>,
    public dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) { }

  ngOnInit(): void {
    this.idElementoGestion = this.data.idElementoGestion;
    this.vinculados = this.data.vinculados
    this.obtenerMediosVerificacion();     
  }

  getCheckbox(medio){ 
     
    if(this.mediosVerificacion[medio].selected){
      this.cantidadAsociada++;
    }else{
      this.mediosVerificacion[medio].comentario = '';
      this.cantidadAsociada--;
    }

    this.estadoChecks();
  }

  estadoChecks(){
  
    if(this.cantidadAsociada == 6){
    
      this.mediosVerificacion.forEach((medio) => {
        
        if(!medio.selected){ 
          medio.disabled = true;
        }
      });
    }else{
      this.mediosVerificacion.forEach((medio) => {
         
          medio.disabled = false;
       
      });
    }
  }

  obtenerMediosVerificacion(){
    this.api.API_POST_obtenerMediosVerificacion(this.storageService.getCurrentUser().idUsuario).subscribe((response) => {
      this.mediosVerificacion = response.payload; 
      this.agregarSeleccionados();
    },
    (err) => {
      console.log(err)
    })
  }
 
  agregarSeleccionados(){
    this.cantidadAsociada = this.vinculados.length;
    for (let m = 0; m < this.mediosVerificacion.length; m++) {
      for (let v = 0; v < this.vinculados.length; v++) { 
        if(this.mediosVerificacion[m].idMedioVerificacion == this.vinculados[v].idMedioVerificacion){
           this.mediosVerificacion[m].selected = true;
           this.mediosVerificacion[m].comentario = this.vinculados[v].comentario;
        }
      }
    }
    
    this.estadoChecks();
    this.cargando = false;
  }
 
  guardarAsociacion(){
      let checks =  document.getElementsByClassName('mat-checkbox-checked');
      let asociados = [];
      for (var i = 0; i < checks.length; i++) {
        if(checks[i].parentElement.parentElement.getElementsByTagName('td')[2].getElementsByTagName('input')[0].value.trim().length == 0){
          alert('falta comentario')
          break;
        }else{
          asociados.push(
            {
              comentario: checks[i].parentElement.parentElement.getElementsByTagName('td')[2].getElementsByTagName('input')[0].value,
              idElementoGestion: this.idElementoGestion,
              idMedioVerificacion: Number(checks[i].id),
              idUsuario: this.storageService.getCurrentUser().idUsuario
            }
          ) 
        }
      }

      this.api.API_POST_vincularMedioAutoevaluacion(asociados).subscribe((response) => {
        this.vinculado = response.payload;
        this.dialogRef.close(this.vinculado);
      },
      (err) => {
        console.log(err)
      })
    
  }


  onNoClick(){
    this.dialogRef.close();
  }

}
